import type { FutureRow } from "@/hooks/useFutureRows";

type EditableVaccination = NonNullable<FutureRow["editableVaccination"]>;
type EditablePlan = NonNullable<FutureRow["editablePlan"]>;

export type UpcomingApplicationDialogContext = {
  petId: string;
  source: "vaccination" | "plan";
  expectedItemId: string | null;
  vaccination?: EditableVaccination | null;
  plan?: EditablePlan | null;
};

const getIdFromValue = (value?: string | { id?: string | null } | null): string | null => {
  if (typeof value === "string") {
    const trimmed = value.trim();
    return trimmed ? trimmed : null;
  }
  if (value && typeof value === "object" && typeof value.id === "string") {
    const trimmed = value.id.trim();
    return trimmed ? trimmed : null;
  }
  return null;
};

export const buildUpcomingContextFromRow = ({
  petId,
  vaccination,
  plan,
}: {
  petId: string;
  vaccination?: EditableVaccination | null;
  plan?: EditablePlan | null;
}): UpcomingApplicationDialogContext => {
  if (plan) {
    return {
      petId,
      source: "plan",
      expectedItemId: plan.item_id,
      plan,
      vaccination: null,
    };
  }

  const expectedItemId = vaccination
    ? getIdFromValue(vaccination.next_application_item_id) ?? getIdFromValue(vaccination.item_id)
    : null;

  return {
    petId,
    source: "vaccination",
    expectedItemId,
    vaccination: vaccination ?? null,
    plan: null,
  };
};
